/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router-dom";
import { MdNearMe } from "react-icons/md";
import { Card, CardTop, CardInfo, CardName, CardDesc, CardDistance, RunningBadge, RunningDot, CardBadge, CardTimes, TimeChip } from "./styled";

function Tabela(props) {
  const navigate = useNavigate();
  let horarioFilter;

  function filterDesc(desc) {
    if (desc.length < 30) {
      return desc;
    }
    return `${desc.substring(0, 27)}...`;
  }

  let horariosShift = {};

  props.data.line.buslineshift.map((h) => {
    const nome = h.shift.name;
    if (nome !== null) {
      if (horariosShift[nome]) {
        horariosShift[nome].push({
          hora: h.hour,
          id: h.id,
          weekday: h.weekday,
          direction_name: h.direction_name,
        });
      } else {
        horariosShift[nome] = [
          {
            hora: h.hour,
            id: h.id,
            weekday: h.weekday,
            direction_name: h.direction_name,
          },
        ];
      }
    } else {
      if (horariosShift[""]) {
        horariosShift[""].push({
          hora: h.hour,
          id: h.id,
          weekday: h.weekday,
          direction_name: h.direction_name,
        });
      } else {
        horariosShift[""] = [
          {
            hora: h.hour,
            id: h.id,
            weekday: h.weekday,
            direction_name: h.direction_name,
          },
        ];
      }
    }

    const checkContains = (days) => {
      return props.data.filter
        .filter((item) => item !== "ida" && item !== "retorno")
        .every((e) => days.includes(e));
    };

    horarioFilter =
      props.data.line.buslineshift &&
      props.data.line.buslineshift.filter((r) => {
        for (let i = 0; i < r.weekday.length; i++) {
          if (
            checkContains(r.weekday[i]) &&
            (props.data.filter.includes(r.direction_name.toLowerCase()) ||
              (!props.data.filter.includes("ida") &&
                !props.data.filter.includes("retorno")))
          ) {
            return true;
          }
        }
        return false;
      });
  });

  const viagem = () => {
    localStorage.setItem("LinhaID", props.data.line.id);
    return navigate("/viagens");
  };

  const mapa = (id) => {
    localStorage.setItem("BuslineShiftID", id);
    return navigate("/mapa");
  };

  //Criei uma variavel hr para fazer a ordenacao das horas do filtro
  const hr = horarioFilter.sort(function (a, b) {
    if (a.hour > b.hour) {
      return 1;
    }
    if (a.hour < b.hour) {
      return -1;
    }
    return 0;
  });

  const distLabel = props.data.distance != null
    ? props.data.distance < 1
      ? `${Math.round(props.data.distance * 1000)}m`
      : `${props.data.distance.toFixed(1)}km`
    : null;

  return (
    <Card onClick={() => viagem()}>
      <CardTop>
        <CardInfo>
          <CardName title={props.data.line.name}>
            {props.data.line.name}
          </CardName>
          <CardDesc title={props.data.line.description}>
            {props.data.line.description}
          </CardDesc>
          {props.data.running && (
            <RunningBadge>
              <RunningDot />
              Em execução
            </RunningBadge>
          )}
          {distLabel && (
            <CardDistance>
              <MdNearMe size={12} />
              {distLabel}
            </CardDistance>
          )}
        </CardInfo>
        <CardBadge>
          {filterDesc(props.data.line.cost_center.name)}
        </CardBadge>
      </CardTop>
      <CardTimes>
        {hr.map((h, index) => (
          <TimeChip
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              mapa(h.id);
            }}
          >
            {h.hour}
          </TimeChip>
        ))}
      </CardTimes>
    </Card>
  );
}
export default Tabela;
